import {
 CustomOptions, LinkedProductType, SalesItemsType, MenuType, ProductType,
} from "app/features/Order/types/OrderTypes";
import { OrderLine } from "app/features/Order/types/ReOrderResponseType";

export const calculateExtraCost = (s: LinkedProductType[]) => {
    let val = 0.00;
    const lineDisplay: string[] = [];
    s.forEach((k) => {
        val += k.price;
        lineDisplay.push(k.name);
    });

    const returnVal: ExtraDisplay = {
        price: val,
        displayLine: lineDisplay,
    };
    return returnVal;
};

export interface ExtraDisplay {
    price: number,
    displayLine: string[];
}

export const getSalesItemsArray = (k: SalesItemsType) => {
    const returnArray: CustomOptions[] = [];
    const defaultOptionArray : LinkedProductType[] = [];
    k?.linkGroups?.forEach((z) => {
            k?.defaultOptions?.forEach((n) => {
            if (n?.linkGroupId === z?.id) {
                const val: CustomOptions = {
                    defaultGroupId: n.linkGroupId,
                    defaultSaleItemId: n.salesItemId,
                    defaultQuantityId: n.defaultQuantity,
                    linkedGroupItems: z.linkedItems,
                    linkedGroupName: z.name,
                };
                returnArray.push(val);
            }
        });
    });
    returnArray.forEach((n) => {
        n.linkedGroupItems.forEach((t) => {
            if (t.id === n.defaultSaleItemId) {
                let m = {} as LinkedProductType;
                m = {...t};
                m.LinkedGroupId = n.defaultGroupId;
                m.LinkedGroupName = n.linkedGroupName;
                defaultOptionArray.push(m);
            }
        });
    });
    return defaultOptionArray;
};

export const getSalesItemsArrayFromPreCustom = (
    currentStoreItems: SalesItemsType,
    recentOrderItems: OrderLine[],
) => {
    const defaultOptionArray : LinkedProductType[] = [];
    const rescentOrderIds = recentOrderItems.map((item) => item.productId.value);
    currentStoreItems?.linkGroups?.forEach((linkGroup) => {
            const {name: LinkedGroupName} = linkGroup;
            linkGroup.linkedItems.forEach((linkedItem) => {
                if (rescentOrderIds.indexOf(linkedItem.productId) > -1) {
                    rescentOrderIds.splice(rescentOrderIds.indexOf(linkedItem.productId), 1);
                    const {id: LinkedGroupId} = linkedItem;
                    defaultOptionArray.push({...linkedItem, LinkedGroupId, LinkedGroupName });
                }
            });
    });
    return defaultOptionArray;
};

export const getSizeLabel = (size: string): string => {
    switch (size) {
        case 'Small':
            return 'Size: Small';
        case 'Medium':
            return 'Size: Medium';
        case 'Large':
            return 'Size: Large';
        default:
            return size;
    }
};
export const getSlicedStatus = (linkedProductType: LinkedProductType) : string => {
    switch (linkedProductType.name) {
        case 'Yes':
            return `${linkedProductType?.LinkedGroupName} ${linkedProductType.name}`;
        case 'No':
            return `${linkedProductType?.LinkedGroupName} ${linkedProductType.name}`;
        case 'None':
            return 'No Sides';
        default:
            return linkedProductType.name;
    }
};

export const flattenMenuProducts = (menu: MenuType[]): Array<ProductType> => {
    if (!menu) {
        return [];
    }
    const flattenArr = menu.map((obj) => obj.groups?.map((g) => g?.products))?.flat(2);
    return flattenArr;
};
